import { Box } from "native-base";

export const VideoDisplayWrapper = ({ children }) => (
  <Box alignItems="flex-start">{children}</Box>
);
